"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./HeroCard.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const HeroCard = /*#__PURE__*/React.forwardRef(({
  title,
  button,
  imageIndex = 1,
  ...otherProps
}, ref) => (0, _pragma.createFelaElement)(_.Card, _extends({
  width: "full",
  css: css.wrapper,
  variant: "secondary",
  ref: ref
}, otherProps), (0, _pragma.createFelaElement)(_.View, {
  flexDirection: "column",
  flex: true,
  alignItems: "flex-start",
  justifyContent: "flex-start"
}, (0, _pragma.createFelaElement)(_.View, {
  flex: true,
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: "xlarge",
  css: css.index
}, (0, _pragma.createFelaElement)(_.Text, {
  children: title,
  color: "text.3",
  css: css.text,
  variant: "heading1"
}), button && button), (0, _pragma.createFelaElement)(_.Portrait, {
  css: css.image,
  variant: imageIndex
}))));
HeroCard.displayName = 'HeroCard';
var _default = HeroCard;
exports.default = _default;
//# sourceMappingURL=HeroCard.js.map